// extracted by mini-css-extract-plugin
export default {"sortList":"TaskSort_sortList__MmapZ","boardSort":"TaskSort_boardSort__bJyqE","boardSortActive":"TaskSort_boardSortActive__RkPtq"};